import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'Ein dewis',
  bestPriceBadge: 'Pris gorau',
  regulatedNotice: {
    prescriptionOnly: 'Ar bresgripsiwn yn unig',
    professionalUse: 'At ddefnydd proffesiynol',
    fromVeterinarian: 'Ar gael gan eich milfeddyg',
    fromPharmacist: 'Ar gael gan fferyllydd',
    noOnlinePurchase: 'Nid yw ar werth ar-lein',
    professionalSupply: 'Ar werth drwy gyflenwyr proffesiynol',
    whyNoLink: "Rydym yn adolygu'r cynnyrch hwn, ond nid ydym yn rhoi dolen iddo.",
  },
};
